<template>
  <!-- Main Header -->
  <header class="main-header">
    <!-- Logo -->
    <a class="logo">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <!-- <span class="logo-mini"><b>C</b>NS</span> -->
      <div class="logo-mini">
        <a>
          <img :src="logoMini.url" :class="logoMini.class" />
        </a>
      </div>
      <!-- logo for regular state and mobile devices -->
      <!-- <span class="logo-lg"><b>CON</b>ASI</span> -->
      <div class="logo-lg"> 
        <a v-if="SITE_NAME_INFO === siteConfigEnum.CONASI_SITE || SITE_NAME_INFO === siteConfigEnum.APOLLO_SITE" style="display: flex">
          <img :src="logoLg.url" :class="logoLg.class"/>
          <div
            v-show="!isNull(projectLogo)"
            class="border-left-vertical-line"></div>
          <img
            v-show="!isNull(projectLogo)"
            :src="projectLogo"
            :class="logoLg.class" />
        </a>
        <a v-else>
          <img :src="logoLg.url" :class="logoLg.class" />
        </a>
      </div>
    </a>

    <!-- Header Navbar -->
    <nav class="navbar navbar-static-top" role="navigation">
      <!-- Sidebar toggle button-->
      <a class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <!-- Messages: style can be found in dropdown.less-->

          <!-- notification alarm -->
          <li class="dropdown notifications-menu">
            <a
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fa fa-bell-o"></i>
              <span class="label label-warning">{{ notification_length }}</span>
            </a>
            <ul class="dropdown-menu">
              <li class="header">
                You have {{ notification_length }} notifications
              </li>
              <li>
                <!-- inner menu: contains the actual data -->
                <ul class="menu">
                  <li v-for="(message, idx) in messages.slice(0, 5)" :key="idx">
                    <a
                      :href="'/case/detail/' + message.params"
                      :title="message.message"
                      v-if="message.read == false"
                      v-on:click="handleClick(message.id)"
                    >
                      <i class="fa fa-comments text-yellow"></i
                      >{{ message.message }}
                    </a>
                  </li>
                </ul>
              </li>
              <li class="footer"><a href="/case/todolist">View all</a></li>
            </ul>
          </li>

          <!-- Project dropdown-->
          <li>
            <a @click="viewProjectList">
              <span>
                {{ getProjectName() }}
                <i class="fa fa-caret-down"></i
              ></span>
            </a>
          </li>
          <!-- Language -->
          <li class>
            <a @click="setLang()">{{ $t("common.select_lang") }}</a>
          </li>
          <!-- User Account Menu -->
          <li class="dropdown user user-menu">
            <!-- Menu Toggle Button -->
            <a class="dropdown-toggle" data-toggle="dropdown">
              <!-- The user image in the navbar-->
              <img :src="avatar" class="user-image" alt="User Image" />
              <!-- hidden-xs hides the username on small devices so only the image appears. -->
              <span class="hidden-xs">{{ fullname }}</span>
            </a>
            <ul class="dropdown-menu">
              <!-- The user image in the menu -->
              <li class="user-header">
                <img :src="avatar" class="img-circle" alt="User Image" />

                <p>
                  {{ fullname }} - {{ GET_ACCOUNT_DATA.privilege_name }}
                  <!-- <small>Last login date {{lastLogin}}</small> -->
                </p>
              </li>
              <!-- Menu Body -->
              <li class="user-body">
                <div class="row">
                  <!-- <div class="col-xs-4 text-center">
                    <a>Followers</a>
                  </div>
                  <div class="col-xs-4 text-center">
                    <a>Sales</a>
                  </div>
                  <div class="col-xs-4 text-center">
                    <a>Friends</a>
                  </div>-->
                </div>
                <!-- /.row -->
              </li>
              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-left">
                  <a
                    class="btn btn-default btn-flat"
                    @click="openProfile()"
                    >Profile</a
                  >
                </div>
                <div class="pull-right">
                  <a
                    class="btn btn-default btn-flat"
                    @click="signOut()"
                    >Sign out</a
                  >
                </div>
              </li>
            </ul>
          </li>
          <li v-if="SITE_NAME_INFO !== siteConfigEnum.CONASI_SITE && SITE_NAME_INFO !== siteConfigEnum.APOLLO_SITE" class>
            <div class="logo-lg">
              <img :src="!isNull(projectLogo) ? projectLogo : rightLogoNaviBar.url"
                :class="rightLogoNaviBar.class" />
            </div>
          </li>
          <!-- Control Sidebar Toggle Button -->
          <!-- <li>
            <a data-toggle="control-sidebar"><i class="fa fa-gears"></i></a>
          </li>-->
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { isCookieEnabled, getCookie } from "tiny-cookie";
import config from "../../../build/config";
import Enum from "../../../enum/enum";
import config_img from "../../lib/config";
import siteImgConfig from '@/lib/siteImgConfig'
import siteConfigEnum from "@/enum/siteConfigEnum";
import utils from '@/lib/utils';

export default {
  name: "lte-navibar",
  data() {
    return {
      img_url: config_img.imgUrlConfig,
      notification_length: 0,
      messages: [],
      userId: null,
      siteImgConfig: siteImgConfig,
      projectLogo: null,
      logoMini: null,
      logoLg: null,
      rightLogoNaviBar: null,
      SITE_NAME_INFO: config.SITE_NAME_INFO,
      siteConfigEnum: siteConfigEnum
    };
  },
  computed: {
    ...mapGetters([
      "GET_ACTIVATED_PROJECT",
      "GET_ACCOUNT_DATA",
      "USER_DETAIL_DATA",
      "TODO_LIST_DATA"
    ]),
    fullname: function() {
      return `${this.GET_ACCOUNT_DATA.lastname} ${
        this.GET_ACCOUNT_DATA.firstname
      }`;
    },
    // lastLogin: function() {
    //   let lastLogin = utils.formatSqlDate(this.GET_ACCOUNT_DATA.lastlogin, null, "MMM Do YYYY")
    //   return lastLogin
    // },
    avatar: function() {
      return this.GET_ACCOUNT_DATA.url_avatar == "" ||
        this.GET_ACCOUNT_DATA.url_avatar == null ||
        this.GET_ACCOUNT_DATA.url_avatar == "profiles/avatar-default.png"
        ? require("../../assets/images/avatar.jpg")
        : this.GET_ACCOUNT_DATA.url_avatar;
      // : this.domainName() + "/media/" + this.GET_ACCOUNT_DATA.url_avatar;
    },
    userRole: function() {
      return this.$store.state.login.role;
    }
  },

  watch: {
    GET_ACTIVATED_PROJECT: function() {
      this.projectLogo = sessionStorage.getItem('projectLogo')
    },
    TODO_LIST_DATA: function() {
      this.messages = [];

      this.TODO_LIST_DATA.forEach((el, idx) => {
        let data = {
          id: el.id,
          message: el.message,
          params: el.profile.id,
          read: el.read
        };
        this.messages.push(data);
        this.notification_length = this.messages.filter(
          el => el.read == false
        ).length;
      });
    }
  },

  methods: {
    ...mapActions([
      "SET_USER_DATA",
      "REMOVE_TOKEN",
      "SET_LANG",
      "GET_TODO_LIST",
      "UPDATE_NOTIFICATION",
      "GET_PROJECT_LIST",
      "GET_ENABLE_MODULE_AND_EXTRA_INFO"
    ]),
    handle_channels(id) {
      // let server_base_url =
      //   configuration.backendConfig.hostname +
      //   ":" +
      //   configuration.backendConfig.port;
      let server_base_url = Enum.domain
      let pathname = config.GROUP_CHANNEL.name + id;
      let ws_scheme = window.location.protocol == "https:" ? "wss" : "ws";
      this.connection = new WebSocket(
        ws_scheme +
          "://" +
          server_base_url +
          "/" +
          config.GROUP_CHANNEL.ws +
          "/" +
          pathname +
          "/"
      );
      var vm = this;
      this.connection.onmessage = function(event) {
        let data = JSON.parse(event.data);
        if (Object.keys(data).length > 0) {
          vm.GET_TODO_LIST();
        }
      };
      this.connection.onopen = function(event) {};
    },
    openProfile() {
      this.$router.push({
        name: "UserAdd",
        params: { id: this.GET_ACCOUNT_DATA.id }
      });
    },
    handleClick(value) {
      let data = {
        id: value
      };
      this.UPDATE_NOTIFICATION(data);
    },
    signOut() {
      let id_token = isCookieEnabled() ? getCookie("id_token") : null;
      this.REMOVE_TOKEN(id_token).then(
        function() {
          this.$router.push({
            name: "Login"
          });
        }.bind(this)
      )
      .catch(
        function(error) {
          this.$router.push({
            name: "Login"
          });
        }.bind(this)
      );
    },
    setLang() {
      let data = this.$i18n.locale === "en" ? "vi" : "en";
      this.SET_LANG(data);
    },
    domainName() {
      let server_base_url = location.origin;
      server_base_url = server_base_url.replace(
        location.hostname,
        configuration.backendConfig.hostname
      );
      if (location.port) {
        server_base_url = server_base_url.replace(
          location.port,
          configuration.backendConfig.port
        );
      }
      if (configuration.backendConfig.subpath) {
        server_base_url =
          server_base_url + "/" + configuration.backendConfig.subpath;
      }
      return server_base_url;
    },
    viewProjectList: function() {
      this.GET_PROJECT_LIST();
      this.$emit("viewProjectList", {});
      sessionStorage.setItem("pathPosition", window.location.pathname);
    },
    isNull: function(value) {
      return utils.isNull(value)
    },
    getProjectName: function() {
      return sessionStorage.getItem('projectName')
    },
    getSiteInfo: function() {
      let results = null
      let index = this.siteImgConfig.findIndex(x=>x.site_name_info_value===config.SITE_NAME_INFO)
      if (index !== -1) {
        results = this.siteImgConfig[index]
      }
      return results
    },
    getLogoData: function(logoName) {
      let results = null
      let dataList = this.getSiteInfo().imgList
      let index = dataList.findIndex(x=>x.name===logoName)
      if (index !== -1) {
        results = dataList[index]
      }
      return results
    }
  },
  beforeMount() {
    this.logoMini = this.getLogoData('mini-logo-sidebar')
    this.logoLg = this.getLogoData('lg-logo-sidebar')
    this.rightLogoNaviBar = this.getLogoData('right-logo-navibar')
    this.GET_ENABLE_MODULE_AND_EXTRA_INFO()
    this.SET_USER_DATA().then(
      function(res) {
        let id = res.data.response.id;
        this.handle_channels(id);
      }.bind(this)
    )
    .catch(
      function(error) {
        //session timeout -> redirect to login
        this.signOut();
      }.bind(this)
    );
  },
  mounted() {
    this.GET_TODO_LIST();
    this.projectLogo = sessionStorage.getItem('projectLogo')
  }
};
</script>
<style scoped>
.resize-lg {
  height: auto;
  width: auto;
  max-width: 150px;
  max-height: 150px;
}
.avatar-resize-lg {
  height: auto;
  width: auto;
  max-width: 100px;
  max-height: 150px;
}
.resize-mini {
  height: auto;
  width: auto;
  max-width: 50px;
  max-height: 50px;
}
.resize-project-logo-lg {
  height: auto;
  width: auto;
  max-width: 50px;
  max-height: 50px;
  padding: 5px;
}
.border-left-vertical-line {
  border-left: 1px solid #DDDDDD;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/NaviBar.vue